import type { SupportedLanguage } from './index'

export const localizedRoutes = {
  home: { it: '', en: '' },
  technologies: { it: 'tecnologie', en: 'technologies' },
  professionalProducts: { it: 'prodotti-da-cabina', en: 'professional-products' },
  supplements: { it: 'integratori', en: 'supplements' },
  training: { it: 'formazione', en: 'training' },
  contacts: { it: 'contatti', en: 'contacts' },
  palermo: { it: 'evento-exclusive-day-palermo', en: 'exclusive-day-palermo' },
  catania: { it: 'evento-exclusive-day-catania', en: 'exclusive-day-catania' },
  privacy: { it: 'privacy', en: 'privacy' },
  terms: { it: 'termini-e-condizioni', en: 'terms-and-conditions' },
  'm-hydro-5d': { it: 'tecnologie/m-hydro-5d', en: 'technologies/m-hydro-5d' },
  'm-laser-pro': { it: 'tecnologie/m-laser-pro', en: 'technologies/m-laser-pro' },
  'm-body-l': { it: 'tecnologie/m-body-l', en: 'technologies/m-body-l' },
  'm-synergy-a': { it: 'tecnologie/m-synergy-a', en: 'technologies/m-synergy-a' },
  'm-body-s': { it: 'tecnologie/m-body-s', en: 'technologies/m-body-s' },
  'm-press': { it: 'tecnologie/m-press', en: 'technologies/m-press' },
  'm-shock': { it: 'tecnologie/m-shock', en: 'technologies/m-shock' },
  'm-rf-synergy': { it: 'tecnologie/m-rf-synergy', en: 'technologies/m-rf-synergy' },
} as const
export type RouteKey = keyof typeof localizedRoutes
export function getLocalizedPath(key: RouteKey, lang: SupportedLanguage): string {
  return `/${lang}${localizedRoutes[key][lang] ? '/' + localizedRoutes[key][lang] : ''}`
}
export function findRouteKeyFromPath(path: string, lang: SupportedLanguage): RouteKey | null {
  return (Object.keys(localizedRoutes) as RouteKey[]).find(key => localizedRoutes[key][lang] === path.replace(/^\/|\/$/g, '')) ?? null
}
export function resolveLocalizedTo(to: string, lang: SupportedLanguage): string {
  if (/^(https?:|mailto:|tel:)/.test(to) || /^\/admin(?:\/|$)/.test(to)) return to
  const [, base = '', suffix = ''] = to.match(/^([^?#]*)(.*)$/) ?? []
  if (base in localizedRoutes) return getLocalizedPath(base as RouteKey, lang) + suffix
  if (!base) return suffix
  return `/${lang}/${base.replace(/^\//, '')}${suffix}`
}
export function switchLocalizedPath(pathname: string, lang: SupportedLanguage): string {
  const [, current, ...segments] = pathname.split('/')
  const path = segments.join('/').replace(/\/$/, '')
  const key = current === 'it' || current === 'en' ? findRouteKeyFromPath(path, current) : null
  return key ? getLocalizedPath(key, lang) : `/${lang}${path ? '/' + path : ''}`
}
